'use client'

import { ClientLabel } from 'labels/client'
import { useLabels } from 'labels/hooks/useLabels/useLabels'

import { PRIVACY_POLICY_PAGE_PATHNAME } from '../../constants/constants'
import { useChatBotMessages } from '../../hooks/useChatBotMessages'

import text from 'fukku/styles/texts.module.scss'
import { useState } from 'react'
import { cx } from 'utils/cx'
import styles from './LegalPolicies.module.scss'

export function LegalPolicies() {
	const { t } = useLabels()
	const { hasHumanInteraction } = useChatBotMessages()

	const [shouldShowPrivacyMessageDOM, setShouldShowPrivacyMessageDOM] =
		useState(!hasHumanInteraction)

	const onPrivacyMessageTransitionEnd = (): void => {
		setShouldShowPrivacyMessageDOM(false)
	}

	return (
		shouldShowPrivacyMessageDOM && (
			<p
				className={cx(
					styles.legalPolicies,
					text.bodyS,
					hasHumanInteraction && styles.hidden
				)}
				onTransitionEnd={onPrivacyMessageTransitionEnd}
			>
				<ClientLabel
					placeholderValues={{ PrivacyPolicy: PRIVACY_POLICY_PAGE_PATHNAME }}
				>
					{t('assistant.legal.privacy.text')}
				</ClientLabel>
			</p>
		)
	)
}
